export const abi = [
    {
        constant: true,
        inputs: [],
        name: "DOMAIN_SEPERATOR",
        outputs: [
            {
                name: "",
                type: "bytes32",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "activate",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "activated",
        outputs: [
            {
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "MIN_TRANSFER_TIMESPAN",
        outputs: [
            {
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                name: "",
                type: "address",
            },
        ],
        name: "userGameId",
        outputs: [
            {
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                name: "",
                type: "address",
            },
        ],
        name: "pendingReturns",
        outputs: [
            {
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                name: "_gameIdCntr",
                type: "uint256",
            },
        ],
        name: "setGameIdCntr",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "profitTransferTimeSpan",
        outputs: [
            {
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "minStake",
        outputs: [
            {
                name: "",
                type: "uint128",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "withdraw",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "unpause",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "lastProfitTransferTimestamp",
        outputs: [
            {
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "BET_TYPEHASH",
        outputs: [
            {
                name: "",
                type: "bytes32",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "claimOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "addHouseStake",
        outputs: [],
        payable: true,
        stateMutability: "payable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "MIN_TIMEOUT",
        outputs: [
            {
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "timePaused",
        outputs: [
            {
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "conflictRes",
        outputs: [
            {
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "paused",
        outputs: [
            {
                name: "",
                type: "bool",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                name: "value",
                type: "uint256",
            },
        ],
        name: "withdrawHouseStake",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "destroy",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [
            {
                name: "",
                type: "uint256",
            },
        ],
        name: "gameIdGame",
        outputs: [
            {
                name: "status",
                type: "uint8",
            },
            {
                name: "stake",
                type: "uint128",
            },
            {
                name: "gameType",
                type: "uint8",
            },
            {
                name: "roundId",
                type: "uint32",
            },
            {
                name: "betNum",
                type: "uint256",
            },
            {
                name: "betValue",
                type: "uint256",
            },
            {
                name: "balance",
                type: "int256",
            },
            {
                name: "userSeed",
                type: "bytes32",
            },
            {
                name: "serverSeed",
                type: "bytes32",
            },
            {
                name: "endInitiatedTime",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "pause",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "withdrawAll",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                name: "_roundId",
                type: "uint32",
            },
            {
                name: "_gameType",
                type: "uint8",
            },
            {
                name: "_num",
                type: "uint256",
            },
            {
                name: "_value",
                type: "uint256",
            },
            {
                name: "_balance",
                type: "int256",
            },
            {
                name: "_serverHash",
                type: "bytes32",
            },
            {
                name: "_userHash",
                type: "bytes32",
            },
            {
                name: "_gameId",
                type: "uint256",
            },
            {
                name: "_serverSig",
                type: "bytes",
            },
            {
                name: "_userSeed",
                type: "bytes32",
            },
        ],
        name: "userEndGameConflict",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "houseProfit",
        outputs: [
            {
                name: "",
                type: "int256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "owner",
        outputs: [
            {
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                name: "_roundId",
                type: "uint32",
            },
            {
                name: "_gameType",
                type: "uint8",
            },
            {
                name: "_num",
                type: "uint256",
            },
            {
                name: "_value",
                type: "uint256",
            },
            {
                name: "_balance",
                type: "int256",
            },
            {
                name: "_serverHash",
                type: "bytes32",
            },
            {
                name: "_userHash",
                type: "bytes32",
            },
            {
                name: "_gameId",
                type: "uint256",
            },
            {
                name: "_userSig",
                type: "bytes",
            },
            {
                name: "_userAddress",
                type: "address",
            },
            {
                name: "_serverSeed",
                type: "bytes32",
            },
            {
                name: "_userSeed",
                type: "bytes32",
            },
        ],
        name: "serverEndGameConflict",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "MAX_TRANSFER_TIMSPAN",
        outputs: [
            {
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                name: "_gameId",
                type: "uint256",
            },
        ],
        name: "userCancelActiveGame",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                name: "_profitTransferTimeSpan",
                type: "uint256",
            },
        ],
        name: "setProfitTransferTimeSpan",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "activateConflictResolution",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "newConflictRes",
        outputs: [
            {
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                name: "_userAddress",
                type: "address",
            },
            {
                name: "_gameId",
                type: "uint256",
            },
        ],
        name: "serverCancelActiveGame",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                name: "_gameId",
                type: "uint256",
            },
        ],
        name: "userForceGameEnd",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "TIMEOUT_DESTROY",
        outputs: [
            {
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "EIP712DOMAIN_TYPEHASH",
        outputs: [
            {
                name: "",
                type: "bytes32",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "houseStake",
        outputs: [
            {
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                name: "_newConflictResAddress",
                type: "address",
            },
        ],
        name: "updateConflictResolution",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                name: "_userAddress",
                type: "address",
            },
            {
                name: "_gameId",
                type: "uint256",
            },
        ],
        name: "serverForceGameEnd",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                name: "_minStake",
                type: "uint128",
            },
            {
                name: "_maxStake",
                type: "uint128",
            },
        ],
        name: "setStakeRequirements",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "houseAddress",
        outputs: [
            {
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "serverAddress",
        outputs: [
            {
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "updateTime",
        outputs: [
            {
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "MAX_TIMEOUT",
        outputs: [
            {
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "pendingOwner",
        outputs: [
            {
                name: "",
                type: "address",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "activeGames",
        outputs: [
            {
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "maxStake",
        outputs: [
            {
                name: "",
                type: "uint128",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                name: "_houseAddress",
                type: "address",
            },
        ],
        name: "setHouseAddress",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                name: "_newOwner",
                type: "address",
            },
        ],
        name: "transferOwnership",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: true,
        inputs: [],
        name: "gameIdCntr",
        outputs: [
            {
                name: "",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "view",
        type: "function",
    },
    {
        constant: false,
        inputs: [],
        name: "transferProfitToHouse",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        inputs: [
            {
                name: "_serverAddress",
                type: "address",
            },
            {
                name: "_minStake",
                type: "uint128",
            },
            {
                name: "_maxStake",
                type: "uint128",
            },
            {
                name: "_conflictResAddress",
                type: "address",
            },
            {
                name: "_houseAddress",
                type: "address",
            },
            {
                name: "_chainId",
                type: "uint256",
            },
        ],
        payable: false,
        stateMutability: "nonpayable",
        type: "constructor",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "user",
                type: "address",
            },
            {
                indexed: true,
                name: "gameId",
                type: "uint256",
            },
            {
                indexed: false,
                name: "stake",
                type: "uint128",
            },
            {
                indexed: true,
                name: "serverEndHash",
                type: "bytes32",
            },
            {
                indexed: false,
                name: "userEndHash",
                type: "bytes32",
            },
        ],
        name: "LogGameCreated",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "user",
                type: "address",
            },
            {
                indexed: true,
                name: "gameId",
                type: "uint256",
            },
        ],
        name: "LogUserRequestedEnd",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "user",
                type: "address",
            },
            {
                indexed: true,
                name: "gameId",
                type: "uint256",
            },
        ],
        name: "LogServerRequestedEnd",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "user",
                type: "address",
            },
            {
                indexed: true,
                name: "gameId",
                type: "uint256",
            },
            {
                indexed: false,
                name: "roundId",
                type: "uint32",
            },
            {
                indexed: false,
                name: "balance",
                type: "int256",
            },
            {
                indexed: false,
                name: "reason",
                type: "uint8",
            },
        ],
        name: "LogGameEnded",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                name: "minStake",
                type: "uint256",
            },
            {
                indexed: false,
                name: "maxStake",
                type: "uint256",
            },
        ],
        name: "LogStakeLimitsModified",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                name: "newConflictResolutionAddress",
                type: "address",
            },
        ],
        name: "LogUpdatingConflictResolution",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: false,
                name: "newConflictResolutionAddress",
                type: "address",
            },
        ],
        name: "LogUpdatedConflictResolution",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "LogPause",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "LogUnpause",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [],
        name: "LogActive",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                name: "newOwner",
                type: "address",
            },
        ],
        name: "LogOwnerShipTransferred",
        type: "event",
    },
    {
        anonymous: false,
        inputs: [
            {
                indexed: true,
                name: "previousOwner",
                type: "address",
            },
            {
                indexed: true,
                name: "newOwner",
                type: "address",
            },
        ],
        name: "LogOwnerShipTransferInitiated",
        type: "event",
    },
    {
        constant: false,
        inputs: [
            {
                name: "_userEndHash",
                type: "bytes32",
            },
            {
                name: "_previousGameId",
                type: "uint256",
            },
            {
                name: "_createBefore",
                type: "uint256",
            },
            {
                name: "_serverEndHash",
                type: "bytes32",
            },
            {
                name: "_serverSig",
                type: "bytes",
            },
        ],
        name: "createGame",
        outputs: [],
        payable: true,
        stateMutability: "payable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                name: "_roundId",
                type: "uint32",
            },
            {
                name: "_balance",
                type: "int256",
            },
            {
                name: "_serverHash",
                type: "bytes32",
            },
            {
                name: "_userHash",
                type: "bytes32",
            },
            {
                name: "_gameId",
                type: "uint256",
            },
            {
                name: "_contractAddress",
                type: "address",
            },
            {
                name: "_userAddress",
                type: "address",
            },
            {
                name: "_userSig",
                type: "bytes",
            },
        ],
        name: "serverEndGame",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
    {
        constant: false,
        inputs: [
            {
                name: "_roundId",
                type: "uint32",
            },
            {
                name: "_balance",
                type: "int256",
            },
            {
                name: "_serverHash",
                type: "bytes32",
            },
            {
                name: "_userHash",
                type: "bytes32",
            },
            {
                name: "_gameId",
                type: "uint256",
            },
            {
                name: "_contractAddress",
                type: "address",
            },
            {
                name: "_serverSig",
                type: "bytes",
            },
        ],
        name: "userEndGame",
        outputs: [],
        payable: false,
        stateMutability: "nonpayable",
        type: "function",
    },
] as const;
